function LockoutMessage(props) {
  const { userEmail } = props;

  return (
    <div>
      <p>
        Too many consecutive attempts to log in with email address: <b>{userEmail}</b>.
      </p>
      <p>If an account exists with this email address, it has been locked.</p>
      <p>Account is locked for the next three minutes.</p>
      <p>If this is your account, check your email inbox for further instructions.</p>
      <hr />
    </div>
  );
}

export default LockoutMessage;
